var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-vacancies" }, [
    _c("div", { staticClass: "page-vacancies__container" }, [
      _c("div", { staticClass: "page-vacancies__vacancies-info-block" }, [
        _c(
          "div",
          { staticClass: "page-vacancies__vacancies-info" },
          [
            _c("h4", { staticClass: "page-vacancies__vacancies-name" }, [
              _c(
                "a",
                {
                  staticClass: "page-vacancies__vacancies-link",
                  attrs: { href: "/vacancy/" + _vm.vacancy.id },
                },
                [_vm._v(" " + _vm._s(_vm.vacancy.title) + " ")]
              ),
            ]),
            _vm._v(" "),
            _vm.isNewDate(_vm.vacancy.start_published)
              ? _c("LabelNew", {
                  staticClass: "page-vacancies__new-vacancies-info",
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.vacancy.salary_from
          ? _c(
              "div",
              {
                staticClass:
                  "h4 color--main-ground-light page-vacancies__vacancies-price",
              },
              [
                _vm._v(
                  "\n        от " +
                    _vm._s(_vm.getFormattedSalary(_vm.vacancy.salary_from)) +
                    " "
                ),
                _vm.vacancy.salary_to
                  ? _c("span", [
                      _vm._v(
                        " до " +
                          _vm._s(
                            _vm.getFormattedSalary(_vm.vacancy.salary_to)
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm._v("  ₽\n      "),
              ]
            )
          : _c(
              "div",
              {
                staticClass:
                  "h4 color--main-ground-light page-vacancies__vacancies-price",
              },
              [_vm._v("\n        По договоренности\n      ")]
            ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-vacancies__vacancies-data" }, [
        _c(
          "div",
          {
            staticClass:
              "page-vacancies__vacancies-location m-t-u color--main-ground-light",
          },
          [
            _c("IconLocation"),
            _vm._v("\n        " + _vm._s(_vm.vacancy.city) + "\n      "),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "page-vacancies__vacancies-date m-t-u color--main-ground-light",
          },
          [
            _c("IconCalendar"),
            _vm._v("\n        Опубликовано "),
            _vm.vacancy.start_published
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.getDateFormatISO(_vm.vacancy.start_published)
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-vacancies__vacancies-detail" }, [
        _c("p", { staticClass: "page-vacancies__vacancies-description" }, [
          _vm._v("\n        " + _vm._s(_vm.vacancy.description) + "\n      "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-vacancies__vacancies-logo" }, [
        _vm.vacancy.sponsor.logo
          ? _c("div", [
              _c(
                "a",
                {
                  staticClass: "page-vacancies__vacancies-logo-link",
                  attrs: { href: _vm.vacancy.sponsor.site },
                },
                [
                  _c("img", {
                    staticClass: "page-vacancies__vacancies-logo-img",
                    attrs: { src: _vm.vacancy.sponsor.logo, alt: "logo" },
                  }),
                ]
              ),
            ])
          : _c("div", [
              _c("p", { staticClass: "page-vacancies__vacancies-logo-text" }, [
                _c(
                  "a",
                  {
                    staticClass: "page-vacancies__vacancies-logo-link",
                    attrs: { href: "" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.vacancy.sponsor.name) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-vacancies__dividing-line" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }